module.exports = __webpack_public_path__ + "static/media/w-2_04.1440bbc8.png";